import store from "../../store"
import { getFormatedDate } from "../../utils/common"

export const Reprint = async (orderObj) => {
  // Extract data from the order object
  const {
    billNo,
    amount,
    items,
    orderType,
    tableVPA,
    customerName,
    orderStatus,
    billStatus,
    paymentmethod,
    createdAt,
    billTxnLogs,
    tableDetails,
  } = orderObj

  // Get hotel data from store
  const hotelData = {
    name: store.restaurantInfo.name,
    address: store.restaurantInfo.address,
    contact: store.restaurantInfo.contact,
    isGST: store.GST.active,
    GSTN: store.GST.gstNumber,
    FSSAI: store.GST.fassi_no
  }

  // Format date and time
  const dateTime = createdAt || new Date().toISOString()
  const date = new Date(dateTime)
  const formattedDateTime = getFormatedDate(date)
  // Get table information
  const table = tableDetails?.tableNo || (tableVPA ? tableVPA.split("@")[0].replace("QRapid", "") : "NA")

  // Filter valid items
  const validItems = items.filter((item) => !item.isCancelled && item.quantity > 0)

  // Calculate totals
  const subTotal = billTxnLogs?.subTotal || billTxnLogs?.beforeDiscountTotal || amount
  const discount = billTxnLogs?.discount || 0
  const discountFlat = billTxnLogs?.discountFlat || 0
  const discountPercent = billTxnLogs?.discountPercent || 0
  const cgst = billTxnLogs?.cgst || 0
  const sgst = billTxnLogs?.sgst || 0
  const tips = billTxnLogs?.tip || billTxnLogs?.tips || 0
  const total = amount

  // Build the HTML for the bill
  const billHtml = `
    <html>
      <head>
        <title>Bill Receipt - ${billNo}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            background-color: white;
          }
          .bill-container {
            padding: 8px;
            width: 100%;
            max-width: 250px;
          }
          .text-center {
            text-align: center;
          }
          .divider {
            margin: 8px 0;
            border-top: 1px dashed #000;
          }
          .mb-10 {
            margin-bottom: 10px;
          }
          .mb-5 {
            margin-bottom: 5px;
          }
          .mt-10 {
            margin-top: 10px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
          .text-right {
            text-align: right;
          }
          .text-left {
            text-align: left;
          }
          .text-bold {
            font-weight: bold;
          }
          .font-sm {
            font-size: 0.75rem;
          }
          .font-xs {
            font-size: 0.65rem;
          }
          .font-md {
            font-size: 0.85rem;
          }
          .font-lg {
            font-size: 1rem;
          }
          .capitalize {
            text-transform: capitalize;
          }
          .item-row td {
            padding: 3px 0;
          }
        </style>
      </head>
      <body>
        <div class="bill-container">
          <!-- Header -->
          <div class="text-center mb-10">
            <h2 style="font-size: 1.1rem; font-weight: bold; margin: 0 0 5px 0;">${hotelData.name}</h2>
            <p style="font-size: 0.7rem; margin: 0 0 5px 0; line-height: 1.1;">${hotelData.address}</p>
            ${hotelData.contact ? `<p style="font-size: 0.7rem; margin: 0 0 5px 0; line-height: 1.1;">${hotelData.contact}</p>` : ""}
            ${hotelData.isGST ? `<p style="font-size: 0.7rem; margin: 0 0 5px 0; line-height: 1.1;"> GSTN: ${hotelData.GSTN || ''}</p>` : ""}
            ${hotelData.isGST ? `<p style="font-size: 0.7rem; margin: 0 0 5px 0; line-height: 1.1;"> FSSAI: ${hotelData.FSSAI || ''}</p>` : ""}

            <div class="divider"></div>
          </div>

          <!-- Bill Info -->
          <div class="mb-10">
            <table class="font-sm">
              <tr>
                <td><strong>Bill No:</strong> ${billNo}</td>
                <td class="text-right"><strong>Date:</strong> ${formattedDateTime}</td>
              </tr>
              <tr>
                <td><strong>Table:</strong> ${table}</td>
                <td class="text-right"><strong>Status:</strong> ${billStatus}</td>
              </tr>
            </table>
            
            <!-- Customer Info -->
            ${
              customerName !== "NA" && customerName !== ""
                ? `<div class="divider"></div>
              <div class="font-sm">
                <p style="margin: 0 0 3px 0;"><strong>Customer:</strong> ${customerName}</p>
              </div>`
                : ""
            }
            
            <div class="divider"></div>
          </div>

          <!-- Items -->
          <div class="mb-10">
            <table class="font-sm">
              <thead>
                <tr style="border-bottom: 1px solid #ddd;">
                  <th class="text-left" style="padding-bottom: 5px;">Item</th>
                  <th class="text-right" style="padding-bottom: 5px;">Qty</th>
                  <th class="text-right" style="padding-bottom: 5px;">Price</th>
                  <th class="text-right" style="padding-bottom: 5px;">Amount</th>
                </tr>
              </thead>
              <tbody>
                ${validItems
                  .map(
                    (item) => `
                  <tr class="item-row">
                    <td class="text-left">
                      <strong>${item.name}</strong>
                      ${item.variantName ? `<br><span class="font-xs" style="color: #555;">- ${item.variantName}</span>` : ""}
                    </td>
                    <td class="text-right">${item.quantity}</td>
                    <td class="text-right">${Number(item.price).toFixed(2)}</td>
                    <td class="text-right">${(Number(item.quantity) * Number(item.price)).toFixed(2)}</td>
                  </tr>
                `,
                  )
                  .join("")}
              </tbody>
            </table>
            <div class="divider"></div>
          </div>

          <!-- Summary -->
          <div class="mb-10">
            <table class="font-sm">
              <tr>
                <td class="text-right"><strong>Sub Total:</strong></td>
                <td class="text-right" style="width: 80px;">₹${Number(subTotal).toFixed(2)}</td>
              </tr>
              
              ${
                discountFlat > 0
                  ? `
                <tr>
                  <td class="text-right"><strong>Flat Discount:</strong></td>
                  <td class="text-right">₹${Number(discountFlat).toFixed(2)}</td>
                </tr>
              `
                  : ""
              }
              
              ${
                discountPercent > 0
                  ? `
                <tr>
                  <td class="text-right"><strong>Discount (${discountPercent}%):</strong></td>
                  <td class="text-right">₹${Number( Number(discountPercent) * Number(subTotal) / 100).toFixed(2)}</td>
                </tr>
              `
                  : ""
              }
              
              ${
                cgst > 0
                  ? `
                <tr>
                  <td class="text-right"><strong>CGST (${billTxnLogs.cgstPercent}%):</strong></td>
                  <td class="text-right">₹${Number(cgst).toFixed(2)}</td>
                </tr>
                <tr>
                  <td class="text-right"><strong>SGST (${billTxnLogs.sgstPercent}%):</strong></td>
                  <td class="text-right">₹${Number(sgst).toFixed(2)}</td>
                </tr>
              `
                  : ""
              }
              
              ${
                tips > 0
                  ? `
                <tr>
                  <td class="text-right"><strong>Tips:</strong></td>
                  <td class="text-right">₹${Number(tips).toFixed(2)}</td>
                </tr>
              `
                  : ""
              }
              
              <tr>
                <td class="text-right text-bold font-md" style="padding-top: 5px;"><strong>Grand Total:</strong></td>
                <td class="text-right text-bold font-md" style="padding-top: 5px;">₹${Number(total).toFixed(2)}</td>
              </tr>
            </table>
          </div>

          <!-- Payment Info -->
          <div class="mb-10">
            <table class="font-sm">
              <tr>
                <td><strong>Payment Method:</strong></td>
                <td class="text-right capitalize">${paymentmethod}</td>
              </tr>
            </table>
          </div>

          <!-- Footer -->
          <div class="mt-10">
            <div class="divider"></div>
            ${
              billTxnLogs?.gst && !billTxnLogs?.gstExcluded
                ? `<p class="text-center font-xs mb-5">GST Already Included in Item Price</p>`
                : ""
            }
            <p class="text-center font-xs">Powered by QRapid</p>
          </div>
        </div>

        <script>
          window.onload = function() {
            window.setTimeout(function() {
              window.print();
              window.setTimeout(function() {
                window.close();
              }, 500);
            }, 300);
          }
        </script>
      </body>
    </html>
  `

  // Open a new window for printing
  const WinPrint = window.open("", "", "width=400,height=600")
  WinPrint.document.write(billHtml)
  WinPrint.document.close()
  WinPrint.focus()

  return
}
